import { render, staticRenderFns } from "./viewImage.vue?vue&type=template&id=60c38c5a&"
import script from "./viewImage.vue?vue&type=script&lang=js&"
export * from "./viewImage.vue?vue&type=script&lang=js&"
import style0 from "./viewImage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports